import React from "react";
import { Container, Card, Badge } from "react-bootstrap";

const PrivacyPolicyPage = () => {
	return (
		<Container>
			<h1 className="text-start mt-4 mb-4 text-info fw-bold">PRIVACY POLICY</h1>

			<Card className="shadow mb-4 bg-dark text-white">
				<Card.Body>
					<Card.Text className="mb-4">
						This website is owned and operated by Kurtis Gassewitz, Davi Birks,
						and Adam Dayson. Kurtis Gassewitz is the data controller and can be
						contacted at:{" "}
						<a href="mailto:info@theracecompanion.com">
						info@theracecompanion.com
						</a>
					</Card.Text>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Purpose
						</Badge>
						Policy Scope
					</Card.Title>

					<div className="mb-4">
						<p>This privacy policy outlines:</p>
						<ul>
							<li>The personal data we will collect</li>
							<li>Use of collected personal data</li>
							<li>Who has access to the data collected</li>
							<li>The rights of the site users</li>
							<li>The site's cookie policy</li>
						</ul>
						<p>
							The privacy policy applies in addition to the terms and conditions
							of our Site.
						</p>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							GDPR
						</Badge>
						Compliance
					</Card.Title>

					<div className="mb-4">
						<p>
							For users in the European Union, we adhere to the Regulation (EU)
							2016/679 of the European Parliament and of the Council of 27 April
							2016, known as the General Data Protection Regulation (GDPR). For
							users in the UK, we adhere to the GDPR as enshrined in the Data
							Protection Act 2018.
						</p>
						<p>
							We have not appointed a Data Protection Officer as we do not fall
							within the categories of controllers and processors required to
							appoint a Data Protection Officer under Article 37 of GDPR.
						</p>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Consent
						</Badge>
						User Agreement
					</Card.Title>

					<div className="mb-4">
						<p>
							By using our site, users agree that they consent to the conditions
							set out in this Privacy Policy.
						</p>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Legal Basis
						</Badge>
						For Processing
					</Card.Title>

					<div className="mb-4">
						<p>
							We collect and process personal data about users in the EU only
							when we have a legal basis for doing so under Article 6 of the
							GDPR.
						</p>
						<p>
							We rely on the following legal basis to collect and process the
							personal data of users in the EU:
						</p>
						<ul>
							<li>
								Processing of user personal data is necessary for us to take, at
								the request of a user, steps before entering into a contract or
								for the performance of a contract to which a user is a party.
							</li>
						</ul>
						<p>
							If a user does not provide the necessary personal data to perform
							a contract the consequences are as follows: The user may not be
							able to authorize and authenticate, and will not be able to
							participate or be eligible for a prize.
						</p>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Data Collection
						</Badge>
						Personal Data
					</Card.Title>

					<div className="mb-4">
						<p>
							When you visit and use our site, we may automatically collect and
							store the following information:
						</p>
						<ul>
							<li>IP Address</li>
							<li>Location</li>
							<li>Clicked links</li>
							<li>Content Viewed</li>
						</ul>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Data Usage
						</Badge>
						How We Use Your Data
					</Card.Title>

					<div className="mb-4">
						<p>
							The data we collect automatically is used for the following
							purposes:
						</p>
						<ul>
							<li>Statistics</li>
							<li>Contact for winning a prize</li>
						</ul>
						<p>
							We will only market to users who have explicitly accepted
							marketing communications. The advertisements shown on our site are
							our own and are not targeted based on user data.
						</p>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Children
						</Badge>
						Age Restrictions
					</Card.Title>

					<div className="mb-4">
						<p>
							The minimum age to compete for global prizes is 18 years of age.
							We do not knowingly collect or use personal data from children
							under 16 years of age.
						</p>
					</div>

					<Card.Title className="border-bottom pb-2 mb-4">
						<Badge bg="secondary" className="me-2">
							Cookies
						</Badge>
						Cookie Policy
					</Card.Title>

					<div className="mb-4">
						<p>
							A cookie is a small file, stored on a user's hard drive by a
							website. We only use cookies for user authentication and login
							functionality. These cookies do not collect personal data as they
							are first-party cookies. We do not use third-party cookies that
							track any browsing habits.
						</p>
						<p>
							If you choose to disable cookies in your browser, the site may not
							work as expected.
						</p>
					</div>
				</Card.Body>
			</Card>
		</Container>
	);
};

export default PrivacyPolicyPage;
